import { useGraphQLQuery } from '@betterment/js-runtime';
import { Card, Heading, Separator } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { EmergencyFundSettings } from './emergency-fund/EmergencyFundSettings';
import { MajorPurchaseSettings } from './major-purchase/MajorPurchaseSettings';
import { RetirementGrowthSettings } from './retirement-growth/RetirementGrowthSettings';
import { RetirementIncomeSettings } from './retirement-income/RetirementIncomeSettings';

import { ForecasterSettingsLoadingState } from '../../../shared/components/forecaster-settings-loading-state/ForecasterSettingsLoadingState';
import { ForecasterPurposeSettingsDocument } from '../../graphql/forecasterPurposeSettings.generated';

const PurposeSettingsCardView = () => {
  const purposeId = useRequiredParam('purposeId');

  const { data, loading } = useGraphQLQuery(ForecasterPurposeSettingsDocument, {
    variables: { purposeId },
    throwOnError: true,
  });

  if (loading && !data) return <ForecasterSettingsLoadingState withPlanSettings={true} />;

  if (!data) return null;
  const { purpose } = data;

  switch (purpose.__typename) {
    case 'PurposeMajorPurchase':
      return <MajorPurchaseSettings purpose={purpose} />;
    case 'PurposeEmergencyFund':
      return <EmergencyFundSettings purpose={purpose} />;
    case 'PurposeRetirementGrowth':
      return <RetirementGrowthSettings purpose={purpose} />;
    case 'PurposeRetirementIncome':
      return <RetirementIncomeSettings purpose={purpose} />;
    default:
      return null;
  }
};

export const PurposeSettingsCard = () => {
  return (
    <Card css={{ display: 'flex', flexDirection: 'column', gap: 'space.300', padding: 'space.300' }}>
      <Card.Header>
        <Heading variant="title100">Goal settings</Heading>
      </Card.Header>
      <Separator />
      <Card.Content css={{ display: 'flex', flexDirection: 'column', gap: 'space.300' }}>
        <ErrorBoundary fallbackType="inline">
          <PurposeSettingsCardView />
        </ErrorBoundary>
      </Card.Content>
    </Card>
  );
};
